var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -3.5,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_3025_65132_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 4,
    cx: 26,
    cy: 26.5,
    r: 25.5,
    fill: "#EDEDED",
    fillOpacity: 0.16,
    stroke: "url(#paint0_linear_3025_65132)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.5L34 26.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19.5L34 26.5L27 33.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3025_65132_clip_path",
    transform: "translate(4 3.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26.5,
    r: 25.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3025_65132",
    x1: 39.2097,
    y1: 3.61869,
    x2: 12.7934,
    y2: 49.3717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.d619866282dd25083f0566ad3195a90d.svg";
export { ForwardRef as ReactComponent };